import templateForgotPassword from './authentication.forgotPassword.template.html';
import templateLost2FA from './authentication.lost2FDevice.template.html';

/* @ngInject */

export default (
  $scope,
  $mdDialog,
  $timeout,
  webpage,
  cookies,
  authenticationService,
  navigationService,
  uiService,
  INSTANCE
) => {
  $scope.Model = {
    INSTANCE,
    attempts: 0,
    isBrowserSupported: navigationService.isBrowserSupported(),
    isPasswordResetRequested: false,
    isPasswordReset: false,
    isTwoFactor: false,
    isTwoFactorSMS: false,
    isTwoFactorSMSResendAvailable: false,
    isLoading: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Authentication is required');
  if (!$scope.Model.isBrowserSupported) {
    webpage.pageTitle('Browser not supported');
  }

  /*
   * Clear Existing Authentication if user is already Authenticated
   * --------------------------------------------------------------------------------
   */
  if (authenticationService.isAuthenticated()) {
    authenticationService.credentialsClear();
  }

  /*
   * Check if Password-Reset has been Requested
   * --------------------------------------------------------------------------------
   */
  if (cookies.get('stPasswordReset') && cookies.get('stPasswordReset') !== undefined) {
    $scope.Model.isPasswordReset = true;
    cookies.set('stPasswordReset', null, { path: '/' });
    cookies.remove('stPasswordReset', { path: '/' });
  }

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  $scope.authenticate = () => {
    $scope.Model.isLoading = true;
    authenticationService
      .credentialsCheck({
        email: $scope.email,
        password: $scope.password,
        totp: $scope.twoFactorCode,
        rememberDevice: $scope.rememberDevice
      })
      .then((response) => {
        let wait = 1;
        if (!response || response === false) {
          $scope.Model.attempts += 1;
          wait = $scope.Model.attempts ** Math.floor($scope.Model.attempts / 2);
          uiService.toast({
            text: {
              p1: 'E-Mail and password',
              p2: 'you entered',
              p3: 'do not match!'
            },
            warn: true
          });
        } else if (
          response &&
          (response === 'twoFactor:required' || response === 'twoFactor:required:isSMS')
        ) {
          $scope.Model.isTwoFactor = true;
          if (response === 'twoFactor:required:isSMS') {
            $scope.Model.isTwoFactorSMS = true;
            $timeout(() => {
              $scope.Model.isTwoFactorSMSResendAvailable = true;
            }, 1000 * 90);
          }
          uiService.toast({
            text: {
              p1: 'Two-factor',
              p2: 'authentication code',
              p3: 'is required!'
            },
            warn: true
          });
        } else if (response && response === true) {
          navigationService.goToCurrentState();
        }
        $timeout(() => {
          $scope.Model.isLoading = false;
        }, wait * 1000);
      });
  };

  $scope.lost2FDevice = ($event) => {
    $event.stopPropagation();

    function dialogController() {
      this.INSTANCE = INSTANCE;
      this.phone = '';
      this.confirmDialog = function () {
        if (this.phone) {
          $mdDialog.hide(this.phone);
        } else {
          this.phone = '';
          uiService.toast({
            text: {
              p1: 'Your',
              p2: 'phone number',
              p3: 'is required!'
            },
            warn: true
          });
        }
      };
      this.cancelDialog = () => {
        $mdDialog.cancel();
      };
    }

    $mdDialog
      .show({
        template: templateLost2FA,
        controllerAs: '$ctrl',
        controller: dialogController
      })
      .then((phone) => {
        authenticationService
          .twoFactorLost({ email: $scope.email, password: $scope.password, phone })
          .then(() => {
            uiService.toast({
              text: {
                p1: 'Check your phone for',
                p2: 'SMS',
                p3: 'with two-factor code'
              },
              warn: true
            });
          });
      });
  };

  $scope.resendSMS = ($event) => {
    $event.stopPropagation();

    if ($scope.Model.isTwoFactorSMSResendAvailable === true) {
      authenticationService
        .credentialsCheck({
          email: $scope.email,
          password: $scope.password
        })
        .then(() => {
          uiService.toast({
            text: {
              p1: 'Check your phone for',
              p2: 'SMS',
              p3: 'with two-factor code'
            },
            warn: true
          });
          $scope.Model.isTwoFactorSMSResendAvailable = false;
          $timeout(() => {
            $scope.Model.isTwoFactorSMSResendAvailable = true;
          }, 1000 * 90);
        });
    } else {
      uiService.toast({
        text: {
          p1: 'You can try resending',
          p2: 'two-factor code',
          p3: 'after 90 seconds'
        },
        warn: true
      });
    }
  };

  $scope.forgotPassword = ($event) => {
    $event.stopPropagation();
    $mdDialog
      .show({
        template: templateForgotPassword,
        controllerAs: '$ctrl',
        controller() {
          const self = this;
          self.INSTANCE = INSTANCE;
          self.email = '';
          self.emailConfirmation = '';
          self.canSend = () =>
            self.email && self.emailConfirmation && self.email === self.emailConfirmation;
          self.confirmDialog = () => {
            if (self.canSend()) {
              $mdDialog.hide(self.email);
            } else {
              self.email = '';
              self.emailConfirmation = '';
              uiService.toast({
                text: {
                  p1: 'E-Mail addresses',
                  p2: 'you entered',
                  p3: 'do not match!'
                },
                warn: true
              });
            }
          };
          self.cancelDialog = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then((email) => {
        authenticationService.passwordForgot({ email });
        $scope.password = '';
        $scope.Model.isPasswordResetRequested = true;
      });
  };
};
